import { createSlice } from "@reduxjs/toolkit";
import { fetchCanSendMail, updateCanSendMail } from "../thunks/EmailSettingThunk";

const mailSlice = createSlice({
  name: "mail",
  initialState: {
    canSendMail: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ✅ GET
      .addCase(fetchCanSendMail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCanSendMail.fulfilled, (state, action) => {
        state.loading = false;
        state.canSendMail = action.payload?.condition === "Yes" ? true : false;;
      })
      .addCase(fetchCanSendMail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ✅ PUT
      .addCase(updateCanSendMail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCanSendMail.fulfilled, (state, action) => {
        state.loading = false;
        state.canSendMail =
          action.payload?.condition === "Yes" ||
          action.payload?.condition?.condition === "Yes";
      })
      .addCase(updateCanSendMail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default mailSlice.reducer;
